<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="userData === undefined" >
      <h4 class="alert-heading"> {{$t('Error fetching user data')}} </h4>
      <div class="alert-body"> No user found with this user id. Check <b-link class="alert-link" :to="{ name: 'users-list'}" > User List </b-link> for other users. </div>
    </b-alert>

    <template v-if="userData">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-row>
              <b-col cols="12" xl="6" class="d-flex justify-content-between flex-column" >
                <div class="d-flex justify-content-start">
                  <b-avatar :src="userData.avatar" :text="avatarText(userData.full_name)" :variant="`light-${resolveUserRoleVariant(userData.role)}`" size="104px" rounded />
                  <div class="d-flex flex-column ml-1">
                    <div class="mb-1">
                      <h4 class="mb-0"> {{ userData.full_name }} </h4>
                      <span class="card-text">{{ userData.email }}</span>
                    </div>
                    <div class="d-flex flex-wrap">
                      <b-button :to="{ name: 'users-edit', params: { id: userData.id } }" variant="primary" v-if="ability.can('write', 'user')"> {{$t('Edit')}} </b-button>
                      <b-button variant="outline-danger" class="ml-1" @click="deletePopup(userData.id, 'users/deleteUser', 'users')" v-if="ability.can('delete', 'user')"> {{$t('Delete')}} </b-button>
                    </div>
                  </div>
                </div>

              </b-col>
            </b-row>
          </b-card>
          <UserViewUserInfoCard :user-data="userData" />
          <UserViewUserPermissionsCard :permissions="permissions" />
          <UsersViewAccessLogCard :user-data="userData" />
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { BRow, BCol, BAlert, BLink, BCard, BButton, BAvatar } from 'bootstrap-vue'
import ability from '@/libs/acl/ability'
import useUsersList from '../users-list/useUsersList'
import userStoreModule from '../userStoreModule'
import UserViewUserInfoCard from './UserViewUserInfoCard.vue'
import UserViewUserPermissionsCard from './UserViewUserPermissionsCard.vue'
import i18n from '@/libs/i18n'
import popups from '@/hooks/popups'
import UsersViewAccessLogCard from './UsersViewAccessLogCard.vue'

export default {
  components: { BRow, BCol, BAlert, BLink, BCard, BButton, BAvatar, UserViewUserInfoCard, UserViewUserPermissionsCard, UsersViewAccessLogCard },

  setup() {
    const userData = ref(null)
    const permissions = ref(null)
    const USER_APP_STORE_MODULE_NAME = 'users'
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)
    onUnmounted(() => { if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME) })

    store.dispatch('users/fetchUser', { id: router.currentRoute.params.id })
      .then(response => {
        permissions.value = response.data.permissions
        userData.value = response.data.user
      })
      .catch(error => {
        if (error.response.status === 404) {
          userData.value = undefined
        }
      })

    const { resolveUserRoleVariant } = useUsersList()
    const { deletePopup } = popups()

    return {
      userData,
      permissions,
      avatarText,
      resolveUserRoleVariant,
      ability,
      deletePopup
    }
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/variables/_variables.scss';
table tr th {
  color: $primary;
}

table tr th span {
  text-transform: uppercase;
}
</style>
